import styled, { css } from 'styled-components';

import { BaseHeadingStyle } from './headers';

import externalLinkIcon from '../../images/welcome-teachers/external-link.svg';
import { mobileMQ } from './media-utils';

export const Text = styled.p`
    font-family: 'Circe Web';
    font-size: 18px;
    line-height: 140%;
    color: #000;
    margin: 0;
    font-weight: 400;

    & + & {
        margin-top: 16px;
    }

    a {
        color: #0b9cdb;

        &:hover {
            text-decoration: underline;
        }
    }

    ${mobileMQ(css`
        font-size: 16px;
        line-height: 150%;
    `)}
`;

export const BaseTextStyle = styled.div`
    font-family: 'Circe Web';
    font-size: 22px;
    line-height: 140%;
    color: #404040;

    a {
        color: #0b9cdb;

        &:hover {
            text-decoration: underline;
        }
    }

    ${mobileMQ(css`
        font-size: 18px;
        line-height: 150%;
    `)}
`;

export const BaseListStyle = styled.ul`
    font-family: 'Circe Web';
    font-size: 18px;
    line-height: 140%;
    color: #000;
    padding: 0 20px;
    box-sizing: border-box;

    li {
        margin-top: 0;
        margin-bottom: 0;
    }

    ${mobileMQ(css`
        font-size: 18px;
        line-height: 150%;
    `)}

    p + & {
        margin-bottom: 16px;
    }
`;

export const LeadImage = styled.img`
    max-width: 100%;
    height: auto;
    margin-top: -50px;
    max-height: 400px;

    ${mobileMQ(css`
        margin-top: 0;
    `)}
`;

export const H1 = styled(BaseHeadingStyle)`
    font-size: 56px;
    line-height: 100%;
    margin: 30px 0;
    position: relative;

    @media screen and (max-width: 760px) {
        font-size: 38px;
        margin: 24px 0 16px;
    }
`;

export const H2 = styled(BaseHeadingStyle)`
    font-size: 48px;
    line-height: 100%;
    margin: 48px 0 16px;

    @media screen and (max-width: 760px) {
        font-size: 28px;
        margin-top: 32px;
    }
`;

export const Section = styled.div`
    position: relative;
`;

export const SectionTitle = styled(BaseHeadingStyle)`
    font-family: 'Circe Web';
    font-size: 22px;
    line-height: 140%;
    margin: 32px 0 8px;

    @media screen and (max-width: 760px) {
        font-size: 18px;
        line-height: 150%;
        margin-top: 16px;
    }
`;

export const CondensedText = styled(BaseTextStyle)`
    margin: 0;
    max-width: 864px;

    @media screen and (max-width: 760px) {
        font-size: 20px;
        line-height: 160%;
    }
`;

export const UnorderedList = styled(BaseListStyle)`
    margin-bottom: 16px;
    list-style: none;

    li::before {
        content: '•';
        color: inherit;
        display: inline-block;
        width: 20px;
        margin-left: -20px;
        text-align: center;
    }
`;

export const HighlightedText = styled(BaseTextStyle)`
    width: 100%;
    background-color: #ccf1fe;
    border-radius: 16px;
    padding: 24px 32px 32px;
    box-sizing: border-box;
    margin: 16px 0 24px;

    @media screen and (max-width: 760px) {
        padding: 24px;
        margin: 16px 0;
    }
`;

export const PrimaryButton = styled.button`
    font-family: 'Circe Web', sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 16px;
    color: #ffffff;
    background: #0dbdfc;
    border-radius: 8px;
    padding: 16px 24px;
    box-sizing: border-box;
    cursor: pointer;
    outline: none;

    &:hover {
        filter: brightness(105%);
    }

    &.main-block__button {
        margin: 80px 0 0;
        z-index: 100;
        position: relative;

        @media screen and (max-width: 1024px) {
            margin-top: 40px;
        }

        @media screen and (max-width: 760px) {
            margin-top: 340px;
        }
    }

    &.teachers-block__button {
        margin: 64px 0 24px;
    }

    &.centered {
        margin: 0 auto;
        display: block;
    }

    @media screen and (max-width: 760px) {
        width: 100%;
    }
`;

export const Aside = styled.div`
    position: relative;
    left: 100%;
    width: 336px;
    display: block;
    padding-left: 144px;
    box-sizing: border-box;

    .aside-icon {
        height: 64px;
        width: auto;
        margin: -40px 0 8px;
    }

    .aside-text {
        font-family: 'Circe Web';
        color: #404040;
        font-size: 18px;
        line-height: 120%;
    }

    .aside-price {
        position: relative;
        top: -100px;
    }

    .aside-price__amount {
        font-weight: 700;
        font-family: 'Futura PT', sans-serif;
        font-size: 76px;
        line-height: 120px;
        color: #ff9c9f;
    }

    .aside-price__period {
        font-size: 24px;
        line-height: 120%;
        font-family: 'Circe Web';
        font-weight: 700;
        position: absolute;
        right: 0;
        bottom: 20px;
    }

    @media screen and (max-width: 1024px) {
        display: none;
    }
`;

export const AsideNote = styled.div`
    position: absolute;
    top: 0;

    &.aside_get-to {
        top: 36px;
    }

    &.aside_translate {
        top: 63px;
    }

    &.aside_screenrecord {
        top: 154px;

        .aside-link {
            color: #ff9c9f;

            &:before {
                content: '';
                background-image: url(${externalLinkIcon});
                background-repeat: no-repeat;
                background-size: 13px 13px;
                display: inline-block;
                width: 13px;
                height: 13px;
                margin-left: -21px;
                padding-right: 8px;
            }
        }
    }

    &.aside_form {
        top: 74px;
    }

    .aside-link {
        font-family: 'Circe Web';
        color: #000;
        font-size: 18px;
        line-height: 150%;
        text-decoration: none;
        border-bottom: 1px solid;
    }
`;
